import { Box, Card, CardContent, Grid, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { useLocation, useParams } from "react-router-dom";
// import { useLazyGetSpecificUserByIdQuery } from "../../services/users";
import { Agent, UserData } from "../../types/General";
import { ImageModal } from "../../components";
import Loader from "../../helpers/constants/Loader";

import { useGetCustomerByIdApiMutation } from "../../services/registration";
import useTranslation from "../../hooks/Translation";
const Details = () => {
  const { _id } = useParams();
  const t = useTranslation();
  const [ByIdDetails, setByIdDetails] = useState<Agent>();
  const [fetchApi, { isLoading }] = useGetCustomerByIdApiMutation();
  const [open, setOpen] = useState<boolean>(false);
  const [selectedImage, setSelectedImage] = useState<string>("");
  const handleClose = () => {
    setOpen(false);
  };

  const fetchDataById = async () => {
    try {
      const response = await fetchApi({ id: _id }).unwrap();
      if (response.status === 200) {
        setByIdDetails(response?.data || {});
      }
    } catch (error) {
      console.error(error);
    }
  };

  const handleOpenModal = (imageUrl: string) => {
    setSelectedImage(imageUrl);
    setOpen(true);
  };

  useEffect(() => {
    if (_id) {
      fetchDataById();
    }
  }, []);

  return (
    <Card className="cards">
      {/* <Loader isLoad={isLoading} /> */}
      <CardContent sx={{ p: 1 }}>
        <Grid container spacing={2} className="view_box">
          <Grid item lg={2} md={2} sm={6} xs={12}>
            <figure className="profile_img">
              <img
                src={
                  ByIdDetails?.profile_picture?.media_url ||
                  `/static/images/user_placeholder.png`
                }
                alt=""
              />
              <div className="overlay">
                <img
                  onClick={() =>
                    handleOpenModal(
                      ByIdDetails?.profile_picture?.media_url
                        ? ByIdDetails?.profile_picture?.media_url
                        : "/static/images/user_placeholder.png"
                    )
                  }
                  src="/static/images/visibility.png"
                  alt="img"
                />
              </div>
            </figure>
          </Grid>
          <Grid item xs={10} className="view_box_list">
            <Grid container spacing={3}>
              <Grid item lg={4} md={4} sm={6} xs={12}>
                <Box>
                  <Typography component="h5">{t.main.fullName}</Typography>
                  <Typography component="p">
                    {ByIdDetails?.full_name || "-"}
                  </Typography>
                </Box>
              </Grid>

              <Grid item lg={4} md={4} sm={6} xs={12}>
                <Box>
                  <Typography component="h5">{t.main.phoneNumber}</Typography>
                  <Typography component="p">
                    {ByIdDetails?.country_code && ByIdDetails?.phone_no
                      ? `${ByIdDetails.country_code}${" "}${ByIdDetails.phone_no}`
                      : ""}
                  </Typography>
                </Box>
              </Grid>
              <Grid item lg={4} md={4} sm={6} xs={12}>
                <Box>
                  <Typography component="h5">{t.main.email}</Typography>
                  <Typography component="p"> {ByIdDetails?.email}</Typography>
                </Box>
              </Grid>
              <Grid item lg={4} md={4} sm={6} xs={12}>
                <Box>
                  <Typography component="h5">{t.main.businessName}</Typography>
                  <Typography component="p">
                    {" "}
                    {ByIdDetails?.business_name || ""}
                  </Typography>
                </Box>
              </Grid>

              <Grid item lg={4} md={4} sm={6} xs={12}>
                <Box>
                  <Typography component="h5">{t.main.industryType}</Typography>
                  <Typography component="p">
                    {ByIdDetails?.industry_type === 1
                      ? "Retailer"
                      : ByIdDetails?.industry_type === 2
                        ? "Wholesaler"
                        : "Distributer"}
                  </Typography>
                </Box>
              </Grid>
              <Grid item lg={4} md={4} sm={6} xs={12}>
                <Box>
                  <Typography component="h5">{t.main.city}</Typography>
                  <Typography component="p">
                    {ByIdDetails?.address?.city || "-"}
                  </Typography>
                </Box>
              </Grid>
              <Grid item lg={4} md={4} sm={6} xs={12}>
                <Box>
                  <Typography component="h5">{t.main.pinCode}</Typography>
                  <Typography component="p">
                    {ByIdDetails?.address?.pin_code || "-"}
                  </Typography>
                </Box>
              </Grid>
              <Grid item lg={4} md={4} sm={6} xs={12}>
                <Box>
                  <Typography component="h5">{t.main.address}</Typography>
                  <Typography component="p">
                    {ByIdDetails?.address?.business_address || "-"}
                  </Typography>
                </Box>
              </Grid>
              <Grid item lg={4} md={4} sm={6} xs={12}>
                <Box>
                  <Typography component="h5">{t.main.accountStatus}</Typography>
                  <Typography component="p">
                    {ByIdDetails?.is_active === false ? "Active" : "Active"}
                  </Typography>
                </Box>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </CardContent>
      <ImageModal open={open} handleClose={handleClose} image={selectedImage} />
    </Card>
  );
};

export default Details;
